module.exports = __webpack_public_path__ + "static/media/divider.1af46c8c.svg";